export default {
    API_ENDPOINT:`https://petful-server-glaiza-wesley.herokuapp.com/api`,
}